import axios from 'axios'
import camelCaseKeys from 'camelcase-keys'

// Constants
import { mikasaBaseUrl } from '../../constants/env'

const buildMikasaClient = async authSettings => {
  const options = {
    baseURL: mikasaBaseUrl,
    timeout: 30000,
    headers: {
      Accept: 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    },
    transformResponse: [
      data => {
        // Convert mikasa's default kebab-case to camelCase for easier destructuring in Javascript
        let parsedData = null
        try {
          parsedData = camelCaseKeys(JSON.parse(data), { deep: true })
        } catch (e) {}

        return parsedData || data
      },
    ],
  }

  if (authSettings?.scheme) {
    options.headers.Authorization = `${authSettings.scheme} ${authSettings.token}`
  }

  return axios.create(options)
}

export default buildMikasaClient
